import React from 'react'
import Select from 'react-select';

const StatusFilter = ({ value, onChange }) => {

    const options = [
        { value: '', label: 'All' },
        { value: 'consultation_requested', label: 'Consultation Requested' },
        { value: 'consultation_confirmed', label: 'Consultation Confirmed' },
        { value: 'consultation_completed', label: 'Consultation Completed' },
        { value: 'consultation_cancelled', label: 'Consultation Cancelled' },
        { value: 'sessions_requested', label: 'Sessions Requested' },
        { value: 'sessions_approved', label: 'Sessions Approved' },
        { value: 'sessions_rejected', label: 'Sessions Rejected' },
        { value: 'sessions_booked', label: 'Sessions Booked' },
        { value: 'sessions_completed', label: 'Sessions Completed' },
        { value: 'sessions_cancelled', label: 'Sessions Cancelled' },
        { value: 'prescription_approved', label: 'Prescription Approved' },
        { value: 'prescription_rejected', label: 'Prescription Rejected' }
    ];

    const selectedOption = options.find(opt => opt.value === (value || '')) || options[0];

    const changeFilterType = (selectedOption) => {
        onChange(selectedOption && selectedOption.value !== '' ? selectedOption.value : null)
    }

    return <Select
        onChange={changeFilterType}
        value={selectedOption}
        options={options}
        styles={{
            control: (provided) => ({
                ...provided,
                minHeight: '40px',
                fontSize: '12px'
            }),
            menu: (provided) => ({
                ...provided,
                maxHeight: '300px',
                minWidth: '150px',
                overflowY: 'auto',
                zIndex: 9999
            }),
            menuList: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto'
            }),
            option: (provided) => ({
                ...provided,
                fontSize: '12px'
            })
        }}
        menuPlacement="auto"
        menuPosition="fixed"
    />
}

export default StatusFilter